(ns rothko.editor.tag.paths
  (:require [com.rpl.specter :as sp]
            [rothko.editor.document.paths :as document-paths]))

(def TAG?
  [:type
   (sp/pred= :tag)])

(defn tag?
  [index]
  [:script
   (document-paths/safe-nthpath
    index
    TAG?)])
